// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__OX7Ml","avatar":"style_avatar__8j8kN","menuIcon":"style_menuIcon__qiVSu"};